import React from 'react'
import ArrowRightAltOutlinedIcon from '@mui/icons-material/ArrowRightAltOutlined';
import { Link } from 'react-router-dom';

//
function CallToAction() {
    return (
        <section className="call-to-action">
            <div className="container">
                <div className="call-to-action-card">
                    <div className="card-content mr-3">
                        <h2 className="h2 card-title text-primary-green ">Looking to increase customer loyalty or skyrocket your sales?</h2>

                        <p className="card-text">
                            Ask about <strong className='text-white'>DEEPBLUE</strong> products, pricing, implementation, or anything else. Our highly trained reps are standing by, ready to help.
                        </p>
                    </div>
                    <div className='column center'>
                        <Link to="/auth">
                            <button className="btn call-to-action-btn">
                                <span>Try For Free</span>

                                <ArrowRightAltOutlinedIcon />
                            </button>

                        </Link>
                        <div className=" mt-2 text-primary-green">

                            <p> Sign up for free. <strong> No credit card.</strong></p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default CallToAction;